import styles from "./DreamerTypes.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import AcademicWizardsIcon from "./icons/AcademicWizards";
import EliteCompetitorsIcon from "./icons/EliteCompetitors";
import CreativeThinkersIcon from "./icons/CreativeThinkers";
import FoundersInnovatorsIcon from "./icons/FoundersInnovators";
import useTranslationHook from "hooks/useTranslationHook";

const DreamerTypes = () => {
  const { t } = useTranslationHook();

  const DREAMER_CARDS = [
    {
      icon: <AcademicWizardsIcon />,
      title: t("scholarship.components.dreamertypes.academicwizards"),
      description: t("scholarship.components.dreamertypes.academicwizards.description"),
    },
    {
      icon: <EliteCompetitorsIcon />,
      title: t("scholarship.components.dreamertypes.allstarsports"),
      description: t("scholarship.components.dreamertypes.allstarsports.description"),
    },
    {
      icon: <CreativeThinkersIcon />,
      title: t("scholarship.components.dreamertypes.creativegeniuses"),
      description: t("scholarship.components.dreamertypes.creativegeniuses.description"),
    },
    {
      icon: <FoundersInnovatorsIcon />,
      title: t("scholarship.components.dreamertypes.foundersinnovators"),
      description: t("scholarship.components.dreamertypes.foundersinnovators.description"),
    },
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t("scholarship.components.dreamertypes.heading")}</h2>

      {/* Desktop/tablet: card grid */}
      <div className={styles.cardsGrid}>
        {DREAMER_CARDS.map((card) => (
          <div key={card.title} className={styles.card}>
            <div className={styles.cardIcon}>{card.icon}</div>
            <h3 className={styles.cardTitle}>{card.title}</h3>
            <p className={styles.cardDescription}>{card.description}</p>
          </div>
        ))}
      </div>

      {/* Mobile: flat list */}
      <div className={styles.mobileList}>
        {DREAMER_CARDS.map((card, index) => (
          <div key={card.title} className={styles.mobileListItem}>
            <div className={styles.mobileListRow}>
              <div className={styles.mobileListIcon}>{card.icon}</div>
              <div className={styles.mobileListText}>
                <h3 className={styles.mobileListTitle}>{card.title}</h3>
                <p className={styles.mobileListDescription}>{card.description}</p>
              </div>
            </div>
            {index < DREAMER_CARDS.length - 1 && <div className={styles.mobileListDivider} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapperHOC(DreamerTypes, {
  componentName: "DreamerTypes-Scholarship",
  showForChina: true,
});
